import React, { useEffect, useState, useRef } from 'react';
import './Skills.css';

const Skills = React.forwardRef((props, ref) => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const skills = [
    { name: 'React', level: 90, icon: '⚛️', color: '#61dafb' },
    { name: 'React Native', level: 85, icon: '📱', color: '#61dafb' },
    { name: 'JavaScript', level: 88, icon: '🟨', color: '#f7df1e' },
    { name: 'HTML & CSS', level: 95, icon: '🎨', color: '#e34c26' },
    { name: 'Motion Design', level: 80, icon: '🎬', color: '#9d50bb' },
    { name: 'Edição de Fotos', level: 75, icon: '📸', color: '#31a8ff' }
  ];

  return (
    <section ref={(el) => { sectionRef.current = el; if (ref) ref.current = el; }} className="skills">
      <div className="container">
        <h2 className="section-title">Habilidades</h2>
        <p className="section-subtitle">Tecnologias e ferramentas que domino</p>

        <div className={`skills-grid ${isVisible ? 'visible' : ''}`}>
          {skills.map((skill, index) => (
            <div 
              key={index} 
              className="skill-card"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="skill-icon">{skill.icon}</div>
              <h3 className="skill-name">{skill.name}</h3>
              <div className="skill-bar-container">
                <div 
                  className="skill-bar"
                  style={{ 
                    width: isVisible ? `${skill.level}%` : '0%',
                    background: `linear-gradient(90deg, ${skill.color}, ${skill.color}dd)`
                  }}
                >
                  <span className="skill-percentage">{skill.level}%</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});

export default Skills;
